<template>
  <article :class="[{placeholder:!ticket},theme,mode]">
    <picture v-if="ticket" @click="routePush('/movie/' + get(movie, 's') + '/'+dateToSlug(ticket.dt), {item:'cover', label:get(movie, 't')})" v-lazy:background-image="movie.p.m"></picture>
    <picture v-if="!ticket"></picture>
    <aside>
      <div class="info">
        <small :class="{'animated-background':!ticket}">{{ get(ticket, 'fd') }}</small>
        <favorite-icon v-if="ticket && false" :theme="theme" :state="movie.like" :movie="movie.id"></favorite-icon>
      </div>
      <h4 v-if="ticket" @click="routePush('/movie/' + get(movie, 's') + '/' + dateToSlug(ticket.dt), {item:'cover', label:get(movie, 't')})">{{movie.t}}</h4>
      <h4 v-if="!ticket" class="animated-background"></h4>
      <div class="info badges">
        <template v-if="ticket">
        <em v-if="get(movie, 'du')">{{ get(movie, 'du')}} min.</em><em v-if="get(movie, 'g')">{{get(movie, 'g')}}</em><em v-if="get(movie, 'v.value')">{{ '(' + get(movie, 'v.label') + ')'}}</em>
        </template>
        <template v-else><em class="animated-background"></em><em class="animated-background"></em><em class="animated-background"></em></template>
      </div>
      <span class="description">{{ get(movie, 'd') }}</span>
      <kms-button v-if="ticket && detailButton" :to="'/movie/' + get(movie, 's') + '/' + dateToSlug(ticket.dt)" color="black" type="transparent">Details anzeigen</kms-button>
    </aside>
  </article>

</template>

<script>
import FavoriteIcon from '@/components/elements/FavoriteIcon.vue';
import KmsButton from '@/components/elements/KmsButton.vue';
import { get } from 'lodash-es';
export default {
  components: { FavoriteIcon, KmsButton },
  props: {
    ticket: Object,
    theme:String,
    detailButton:Boolean,
    mode:String
  },
  data () {
    return {

    }
  },
  methods: {
    dateToSlug: function(date) {
      return date ? date.d+'/'+date.m+'/'+date.y : null;
    },
    get:get,
  },
  computed: {
    movie : function() {
      return this.ticket ? this.ticket.movie : null;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";
@import "@/sass/_placeholder.scss";
article {
  &.placeholder {
    picture {
      background: #eee;
    }
    aside .info{
      small {
        width: 40%;
      }
      em {
        width: 20%;
      }
    }
  }


  &.light{
     margin-bottom: 6em;
    aside{
      color:black;
      &>.info small{
        font-weight: 700;
      }
      &>h4{
        font-weight: 800;
      }
      &>.info em{
        font-weight: 700;
      }
      &>span{
        margin-right: -0.5em;
      }
    }
  }

  &.dark{
    aside{
      font-size: .7em;
      &>h4{
        font-size:2em;
        margin-top:.2em;
      }
      &>.info.badges {
        margin-top: .4em;
        min-height: 1em;
      }
      &>span{

      }
    }
  }

  picture{
    position: relative;
    width: 100%;
    padding-bottom: 150%;
    display: block;
    background-size: cover;
    background-position: center;
    cursor:pointer;
    background-color:rgba(0,0,0,0.1);
  }
  aside {
    margin-top: 5%;
    color:white;
    display:flex;
    flex-wrap:wrap;
    justify-content: space-between;

    .description{
      display: none;
    }

    &>.info small{
      text-transform: uppercase;
    }
    &>h4{
      width: 100%;
      margin-top: .1em;
      font-size: 1.7em;
      @include for-size(phone-only) {
        font-size: 1.1em;
      }
      line-height: 1.2em;
      font-weight: 700;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      cursor:pointer;
    }
    &>.info{
      width: 100%;
      display: inline-flex;
      margin-bottom:.3em;
      justify-content: space-between;
      em{
        text-transform: uppercase;
        text-align: center;
      }

      &.badges {
        margin-top: .5em;
        min-height: 1.8em;
        color:$grey-text;
      }
    }
  }
  button {
    width:100%;
    margin-top: 0.5em;
    font-size: 1.1em;
  }
  &.list{
    width:100%!important;
    display: flex;
    margin-bottom:2em;
    picture{
      padding:0!important;
      width: 13vw;
      margin-right: 2em;
      height: 19vw;
      box-sizing: border-box;
    }
    aside {
      width:70%;
      margin:0;
      flex-direction: column;
      justify-content: flex-start;
      &>.info{
        width: 50%;
        justify-content: flex-start;
        em{
          margin-right: 1.5em;
        }
      }
      h4{
        margin:0;
      }
      .description{
        display: block;
        width: 100%;
      }
      button{
        width: initial;
        display: block;
        margin: 1em 0 0 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Movie/MovieCover.vue